import * as React from 'react'
import { useState } from 'react'
import { t } from 'ttag'
import AccessibilityNewIcon from '@material-ui/icons/AccessibilityNew'
import YumButton from '../YumButton/YumButton'
import A11ySettingsDialog from './A11ySettingsDialog'

interface IA11ySettingsButtonProps {
  className?: string
  style?: React.CSSProperties
}

export default function A11ySettingsButton({ className, style }: IA11ySettingsButtonProps) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <YumButton
        variant="outlined"
        size="small"
        onClick={() => setOpen(true)}
        title={t`Accessibility settings`}
        aria-label={t`Accessibility settings`}
        className={className}
        style={{
          minWidth: 0,
          //width: 30,
          //height: 30,
          //padding: 0,
          borderRadius: 8,
          ...style,
        }}
      >
        <AccessibilityNewIcon style={{ fontSize: 20 }} />
      </YumButton>
      <A11ySettingsDialog open={open} onClose={() => setOpen(false)} />
    </>
  )
}
